var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"schedule-row button-clear",class:{
		'schedule-row--more': _vm.data.type == 'non',
		'schedule-row--no-shadow': !_vm.shadow
	},style:(_setup.insetCalendarColorVar(_vm.data.calendarThemeColor))},_vm.$listeners),[(_vm.data.type == 'non')?[_c('div',{staticClass:"schedule-row__content"},[_vm._v(_vm._s(_vm.$t('enterprise.more')))]),_c('SvgIcons',{attrs:{"name":"right-light"}})]:_c('div',{staticClass:"schedule-row__content text-overflow"},[_vm._v(_vm._s(_setup.formatScheduleRow))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }